export default "<input type=\"checkbox\" clrCheckbox />\n";